export default (function (colorString) {
  return colorString === '#fff' || colorString === '#ffffff' || colorString === '#FFF' || colorString === '#FFFFFF' || colorString === 'white';
});